export enum HeroBannerVariants {
  h1 = "h1",
  h2 = "h2",
}

export enum JustifyText {
  CENTER = "center",
  LEFT = "left",
}

export enum MediaLayoutValues {
  COVER = "cover",
  CONTAIN = "contain",
}
